import { render, staticRenderFns } from "./ImagePostEditor.vue?vue&type=template&id=1c9f0840&"
import script from "./ImagePostEditor.vue?vue&type=script&lang=js&"
export * from "./ImagePostEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports